var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99991 13.4824C1.99991 12.3778 2.89534 11.4824 3.99991 11.4824C5.65676 11.4824 6.99991 12.8255 6.99991 14.4824V18.4824C6.99991 20.1393 5.65676 21.4824 3.99991 21.4824C2.89534 21.4824 1.99991 20.587 1.99991 19.4824V13.4824Z",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4786 8.78868L15.2123 9.64876C14.9941 10.3535 14.885 10.7059 14.9689 10.9842C15.0368 11.2093 15.1858 11.4034 15.3889 11.5311C15.6399 11.6889 16.0196 11.6889 16.779 11.6889H17.183C19.7531 11.6889 21.0381 11.6889 21.6451 12.4497C21.7144 12.5366 21.7761 12.6291 21.8295 12.7261C22.2964 13.5745 21.7656 14.7175 20.7039 17.0035C19.7296 19.1013 19.2424 20.1502 18.3379 20.7676C18.2504 20.8273 18.1604 20.8837 18.0682 20.9365C17.1159 21.4824 15.9361 21.4824 13.5763 21.4824H13.0645C10.2056 21.4824 8.77619 21.4824 7.88805 20.6219C6.99991 19.7613 6.99991 18.3763 6.99991 15.6063V14.6327C6.99991 13.177 6.99991 12.4492 7.25825 11.783C7.51659 11.1168 8.01126 10.5691 9.0006 9.47354L13.092 4.94298C13.1946 4.82936 13.2459 4.77254 13.2912 4.73317C13.7134 4.3657 14.3651 4.40706 14.7343 4.82477C14.7739 4.86952 14.8171 4.93233 14.9035 5.05796C15.0387 5.25447 15.1063 5.35273 15.1653 5.45007C15.6927 6.32155 15.8523 7.35678 15.6107 8.33957C15.5837 8.44934 15.5487 8.56252 15.4786 8.78868Z",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.f2dece121ef1d68ae5c358f6018127ca.svg";
export { ForwardRef as ReactComponent };